
import React from "react";
import { Line } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartOptions,
} from "chart.js";

// Register Chart.js modules
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
 
);


interface UserActivityChartProps {
  ylabels: [];
  xlabels: [];
}

const UserActivityChart: React.FC<UserActivityChartProps> = ({ ylabels, xlabels }) => {
  const data = {
    labels:xlabels,
    datasets: [
      {
        label: "Completion Rate",
        data: ylabels,
        borderColor: "#57A3FD", // Line color
        // backgroundColor: "rgba(255, 123, 0, 0.3)", // Background fill color under the line
        backgroundColor: (context: any) => {
          // Create linear gradient
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(
            0,
            0,
            0,
            context.chart.height
          );
          gradient.addColorStop(0, "#57A3FD"); // Start color (semi-transparent orange)
          gradient.addColorStop(1, "rgba(255, 255, 255, 0.3)"); // End color (semi-transparent white)
          return gradient;
        },
        pointBackgroundColor: "transparent", // No background color for the point
        pointBorderColor: "#57A3FD", // Border color of the point
        pointBorderWidth: 3, // Border width for the point
        fill: true, // Fill the area under the line
        tension: 0, // Straight lines
        pointStyle: "circle", // Change corner dots to circles
        pointRadius: 5, // Adjust the size of the circle
      },
    ],
  };

  const options: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw}% on ${context.label}`;
          },
        },
        backgroundColor: "#57A3FD",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        cornerRadius: 20,
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Remove grid lines on the x-axis
        },
      },
      y: {
        ticks: {
          callback: (value) => `${value}%`,
          stepSize: 20,
        },
        min: 0,
        max: 100,
        grid: {
          drawBorder: true,
          borderDash: [5, 5],
        } as any,
      },
    },
  };

  return (
    <Box
      sx={{
        padding: 3,
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        maxWidth: "100%",
        margin: "20px auto",
      }}
    >
      <Typography variant="h6" gutterBottom>
      User Activity
      </Typography>
      <Line data={data} options={options} />
    </Box>
  );
};

export default UserActivityChart;